import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=0fbe49a8&scoped=true&"
import script from "./order-list.vue?vue&type=script&lang=js&"
export * from "./order-list.vue?vue&type=script&lang=js&"
import style0 from "./order-list.vue?vue&type=style&index=0&id=0fbe49a8&lang=scss&scoped=true&"
import style1 from "./order-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe49a8",
  null
  
)

export default component.exports